import classNames from 'classnames';
import React from 'react';

import {getActionButtonRoleProps} from 'lib/a11y/ButtonA11y';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {ElementKeyboardEvent, ElementMouseEvent} from 'util/Types';

type HoverIconProps =
  | {
      'aria-label'?: string;
      className?: string;
      dataTestAttrs?: DataTestAttrs;
      icon: BenchlingIconName;
      onClick?: never;
      result?: never;
    }
  | {
      'aria-label': string;
      className?: string;
      dataTestAttrs?: DataTestAttrs;
      icon: BenchlingIconName;
      onClick: (result?: object) => void;
      result?: object;
    };

export default class HoverIcon extends React.Component<HoverIconProps> {
  _handleClick = (e: ElementMouseEvent | ElementKeyboardEvent): void => {
    // Don't propogate so we don't trigger parent handlers.
    e.stopPropagation();
    if (this.props.onClick != null) {
      this.props.onClick(this.props.result);
    }
  };

  override render(): JSX.Element {
    const actionProps =
      this.props.onClick != null
        ? getActionButtonRoleProps({
            onPress: this._handleClick,
          })
        : {};
    return (
      <div
        aria-label={this.props['aria-label']}
        className={classNames('hoverLink', this.props.className)}
        {...actionProps}
        onClick={this.props.onClick != null ? this._handleClick : undefined}
        {...getTestProps(this.props.dataTestAttrs)}
      >
        <BenchlingIcon className="hoverLink-icon" icon={this.props.icon} />
      </div>
    );
  }
}
